import { render, staticRenderFns } from "./selectOptionComment.vue?vue&type=template&id=3cad2e70&scoped=true"
import script from "./selectOptionComment.vue?vue&type=script&lang=js"
export * from "./selectOptionComment.vue?vue&type=script&lang=js"
import style0 from "./selectOptionComment.vue?vue&type=style&index=0&id=3cad2e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cad2e70",
  null
  
)

export default component.exports